import Vue from "vue";
import Router from "vue-router";
import store from "@/store/index";
import Layout from "../views/layout/layout.vue";
import { gotoRoute } from "@/utils/utilsRouter.js";
Vue.use(Router);

export const initRoute = [
  {
    path: "/login",
    component: () => import("../views/login/login.vue"),
  },
  {
    path: "/oauth",
    component: () => import("../views/login/oauth.vue"),
  },
  {
    path: "/resetPassword",
    component: () => import("../views/login/resetPassword.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/h5/inAndOut",
    component: () => import("../views/h5/inAndOut.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/h5/assembly",
    component: () => import("../views/h5/assembly.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/h5/stockInRecord",
    component: () => import("../views/h5/stockRecord.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/h5/stockOutRecord",
    component: () => import("../views/h5/stockRecord.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/h5/assemblyRecord",
    component: () => import("../views/h5/stockRecord.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/h5/disAssemblyRecord",
    component: () => import("../views/h5/stockRecord.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/h5/snList",
    component: () => import("../views/h5/snList.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/h5/goodSnList",
    component: () => import("../views/h5/snList.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/h5/editRecord",
    component: () => import("../views/h5/editRecord.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/h5/index",
    component: () => import("../views/h5/index.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/h5/login",
    component: () => import("../views/h5/login.vue"),
  },
];

const createRouter = () =>
  new Router({
    routes: initRoute,
  });

/* 重置路由，用于每次配置完刷新路由重置 */
export const resetRouter = () => {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
};

/* 初始路由 */
let router = createRouter();

/* 准备动态添加的路由 */
export const DynamicRoutes = [
  {
    path: "",
    component: Layout,
    name: "container",
    redirect: "home",
    meta: {
      requiresAuth: true,
      name: "首页",
    },
    children: [
      {
        id: 1,
        path: "home",
        component: () => import("../views/home/home.vue"),
        name: "home",
        meta: {
          name: "首页",
          icon: "tree",
        },
      },
      {
        path: "/userCenter",
        component: () => import("../views/userCenter/userCenter.vue"),
        name: "userCenter",
        meta: {
          requiresAuth: true,
          name: "个人中心",
        },
      },
      {
        path: "/404",
        component: () => import("../views/status/404.vue"),
        name: "404",
        meta: {
          requiresAuth: true,
          name: "404",
        },
      },
    ],
  },
];

router.beforeEach((to, from, next) => {
  if (!store.state.UserMessage) {
    if (
      to.matched.length > 0 &&
      !to.matched.some((record) => record.meta.requiresAuth)
    ) {
      next();
    } else {
      if (to.path.indexOf("resetPassword") != -1) {
        next();
      } else {
        if (to.path.indexOf("/h5/") != -1) {
          next({ path: "/h5/login" });
        } else {
          next({ path: "/login" });
        }
      }
    }
  } else {
    if (to.path.indexOf("oauth") != -1) {
      next();
    } else if (!store.state.permission.sidebarMenu) {
      store.dispatch("permission/FETCH_PERMISSION").then(() => {
        next({ path: to.path });
      });
    } else {
      if (to.path !== "/login") {
        if (to.matched == 0 && Object.keys(to.meta).length == 0 && !to.name) {
          gotoRoute({
            name: "404",
            meta: {
              name: "404",
            },
          });
        } else {
          next();
        }
      } else {
        next(from.fullPath);
      }
    }
  }
});

router.afterEach((to, from, next) => {
  var routerList = to.matched;
  store.commit("setCrumbList", routerList);
  store.commit("permission/SET_CURRENT_MENU", to.name);
});

/**
 * 重写路由的push方法,多次重复push一个路由会报错
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

export default router;
